var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c(
        "div",
        { ref: "swiper", staticClass: "swiper-container" },
        [
          _c(
            "div",
            { staticClass: "swiper-wrapper" },
            [
              _vm._l(_vm.slides, function(slide, index) {
                return [
                  _c("div", { staticClass: "swiper-slide" }, [
                    _c(
                      "div",
                      { staticClass: "icv", class: "image-compare-" + index },
                      [
                        _c("lazy-img", {
                          attrs: {
                            "picture-class": "icv__img icv__img-a",
                            "image-url": slide.compareImage1
                          },
                          scopedSlots: _vm._u(
                            [
                              slide.compareImage1Mobile
                                ? {
                                    key: "additionalimages",
                                    fn: function() {
                                      return [
                                        _c("source", {
                                          attrs: {
                                            media: "(max-width: 767px)",
                                            srcset: slide.compareImage1Mobile
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                : null
                            ],
                            null,
                            true
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "icv__wrapper" },
                          [
                            _c("lazy-img", {
                              attrs: {
                                "picture-class": "icv__img icv__img-b",
                                "image-url": slide.compareImage2
                              },
                              scopedSlots: _vm._u(
                                [
                                  slide.compareImage2Mobile
                                    ? {
                                        key: "additionalimages",
                                        fn: function() {
                                          return [
                                            _c("source", {
                                              attrs: {
                                                media: "(max-width: 767px)",
                                                srcset:
                                                  slide.compareImage2Mobile
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    : null
                                ],
                                null,
                                true
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "icv__img icv__img-b icv__img--events",
                                style:
                                  "width: " + _vm.markerContainerWidth + "px;"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "position-relative w-100 h-100"
                                  },
                                  [
                                    _vm._l(slide.items, function(item) {
                                      return [
                                        item.markerY && item.markerX
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "position-absolute icv__overlay",
                                                style: {
                                                  top: item.markerY + "%",
                                                  left: item.markerX + "%"
                                                },
                                                on: {
                                                  mousedown: function($event) {
                                                    $event.stopPropagation()
                                                  },
                                                  touchstart: function($event) {
                                                    $event.stopPropagation()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "icv__cta",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toggleOverlay(
                                                          $event,
                                                          item.url
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    +\n                                                "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-none icv__details"
                                                  },
                                                  [
                                                    item.itemData
                                                      ? _c(
                                                          "div",
                                                          [
                                                            _vm._t(
                                                              "reviews-" +
                                                                item.itemData
                                                                  .item.id
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          item.name
                                                        )
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      item.itemData
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "\n                                                            " +
                                                                _vm._s(
                                                                  _vm.getPrice(
                                                                    item.itemData
                                                                  )
                                                                ) +
                                                                "\n                                                        "
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: item.url,
                                                            target: item.openInNewTab
                                                              ? "_blank"
                                                              : "_self"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                            Zum Produkt\n                                                        "
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    })
                                  ],
                                  2
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.slides.length > 1
            ? [
                _c("div", { staticClass: "swiper-pagination" }),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-button-prev" }),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-button-next" })
              ]
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }